<template>
	<div
		:class="{'text-right':params.isRight,'text-semi':params.isBold,'font-black':params.isBold,'multi-hidden':params.multiHidden}"
	>
		<span v-if="params.prefix">{{params.prefix}}</span>
		<span v-if="fieldInfo.type=='Field_enum'">
			<el-tag size="mini" :type="calcTag(value)" disable-transitions>{{value.name}}</el-tag>
		</span>
		<router-link
			:to="{name:'Customer-User-Show',params:{id:value._id}}"
			v-else-if="fieldInfo.type=='Field_userid'"
		>{{value? value.name : ''}}</router-link>
		<!-- <router-link
			:to="{name:'Customer-User-Show',params:{id:value._id}}"
			v-else-if="fieldInfo.type=='Field_adminuser'"
			
		>{{value? value.name : ''}}</router-link>-->
		<span v-else-if="fieldInfo.type=='Field_adminuser'">{{value? value.name : ''}}</span>
		<span v-else-if="fieldInfo.type=='Field_ts'">
			<template v-if="value<=0">-</template>
			<template v-else-if="params.type=='date'">{{value | moment("YYYY-MM-DD")}}</template>
			<template v-else>{{value | moment("YYYY-MM-DD HH:mm")}}</template>
		</span>
		<router-link
			v-else-if="fieldInfo.type=='Field_relate_simple_id' && params.link"
			:to="{name:params.link,params:{id:value._id}}"
		>{{value | Field_relate_simple_id(fieldInfo.name_fields)}}</router-link>
		<span
			v-else-if="fieldInfo.type=='Field_relate_simple_id'"
		>{{value | Field_relate_simple_id(fieldInfo.name_fields)}}</span>
		<span v-else-if="fieldInfo.type=='Field_classify_id'">{{calcArrayName(fieldInfo,value)}}</span>
		<span v-else-if="fieldInfo.type=='Field_region'">{{calcRelateArrayName(value)}}</span>
		<span v-else-if="fieldInfo.type=='Field_bool'" class="text-semi">
			<el-tag size="mini" :type="value?'success':'warning'" disable-transitions>{{value?'是':'否'}}</el-tag>
		</span>
		<span v-else-if="fieldInfo.type=='Field_string' || fieldInfo.type=='Field_mongoid'">{{value}}</span>
		<span v-else-if="fieldInfo.type=='Field_int'">{{value==0 && params.isZeroSlash ? '-':value}}</span>
		<span v-else-if="fieldInfo.type=='Field_float'">{{value==0 && params.isZeroSlash ? '-':value}}</span>
		<el-tooltip :content="value" v-else-if="fieldInfo.type=='Field_text' && params.multiHidden">
			<p :class="{'text-semi':fieldKey.isBold,'multi-hidden':params.multiHidden}">{{value}}</p>
		</el-tooltip>
		<p v-else-if="fieldInfo.type=='Field_text'">{{value}}</p>
		<span v-else-if="fieldInfo.type=='Field_money'">
			<template v-if="value==0">-</template>
			<template v-else>
				<span class="text-semi font-black">{{value}}</span>
			</template>
		</span>
		<div class="relate-item-group" v-else-if="fieldInfo.type=='Field_relate_array'">
			<span
				class="mr-2 relate-item" 
				v-for="(v,index) in value"
				:key="index"
			>{{v | Field_relate_simple_id(fieldInfo.name_fields)}}</span>
		</div>
		<div class="relate-item-group" v-else-if="fieldInfo.type=='Field_simple_array'">
			<div class="mr-2 relate-item" v-for="(item,index) in value" :key="index">
				{{item}}
			</div>
		</div>
		<div v-else-if="fieldInfo.type=='Field_pic'">
			<el-tooltip placement="top" v-if="params.isTooltip && value">
				<div slot="content">
					<img
						:src="value+'?x-oss-process=style/'+fieldInfo.oss_style"
						:alt="fieldInfo.name"
						class="img-thumbnail"
					/>
				</div>
				<span>查看</span>
			</el-tooltip>
			<img
				:src="value+'?x-oss-process=style/'+fieldInfo.oss_style"
				class="img-fluid"
				:class="params.class"
				v-else-if="value"
			/>
		</div>
		<div v-else-if="fieldInfo.type=='Field_text_md'">{{value}}</div>
		<address-show
			v-else-if="fieldInfo.type=='Field_address'"
			:field-info="fieldInfo"
			:data-model-name="fieldInfo.model_name"
			:value="value"
			:params="params"
		>{{value}}</address-show>

		<div v-else-if="fieldInfo.type=='Field_pics'">
			<span class="text-danger" v-if="value.length==0">N/A</span>
			<div class v-else>
				<el-tooltip placement="left-start" v-for="img in value" :key="img">
					<div slot="content">
						<img :src="img+'?x-oss-process=style/thumb'" class="img-thumbnail img-tooltip" />
					</div>
					<span class="el-icon-picture text-success" style="line-height:23px"></span>
				</el-tooltip>
			</div>
		</div>

		<span v-else>{{fieldInfo.type}} : {{value}}</span>
		<el-tooltip placement="left-start" v-if="tooltipImg">
			<div slot="content">
				<img :src="tooltipImg+'?x-oss-process=style/thumb'" class="img-thumbnail img-tooltip" />
			</div>
			<span class="el-icon-picture float-right text-success" style="line-height:23px"></span>
		</el-tooltip>
		<span v-if="params.postfix">{{params.postfix}}</span>
	</div>
</template>

<script>
import AddressShow from "@/widgets/Shows/AddressShow.vue";
import FieldShowRegion from "@/components/Fields/FieldShowRegion";
import Field_relate_simple_id from "@/components/Fields/Field_relate_simple_id";

export default {
	name: "FieldShow",
	filters: { Field_relate_simple_id, FieldShowRegion },
	data() {
		return {};
	},
	props: {
		fieldInfo: {
			type: Object,
		},
		fieldKey: {},
		value: [Object, String, Number, Array, Boolean],
		recordModel: {
			type: String,
			default: "",
		},
		tooltipImg: {
			type: String,
			default: "",
		},
		params: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	mounted() {},
	computed: {},
	methods: {
		calcRelateArrayName(item) {
			// console.log(this.fieldInfo);
			if (item && item.length > 0) {
				let names = [];
				for (let k in item) {
					names.push(item[k].name);
				}
				return names.join(" / ");
			} else {
				return "-";
			}
		},
		calcArrayName(nameFields, item) {
			if (!item) {
				return "-";
			}
			if (item.length > 0) {
				let names = [];
				for (let k in item) {
					names.push(item[k].name);
				}
				return names.join(" / ");
			} else {
				return "-";
			}
		},
		calcTag(value) {
			let index = value.index;
			if (typeof index == "string") {
				let _t = 0;
				for (let i = 0; i < index.length; i++) {
					_t += index.charCodeAt(i);
				}
				index = _t;
			}
			let tags = ["primary", "success", "danger", "warning", "info"];
			return tags[index % tags.length];
		},
	},
	components: {
		AddressShow,
	},
	watch: {},
};
</script>
